import { IAnyObject } from "../interfaces";
import { TDateTime } from "../types";
import { PalletState } from "../enums";

export class Milestone {
	public id: string;
	public label: string;
	public actualEpochTime: number;
	public scheduledEpochTime: number;
	public estimatedEpochTime: number;
	public timezoneOffset: number | null;
	public timeZone: string;
	public code: string;
	public status: string;
	public sequenceNo: number;
	public timeLabel: string;
	public dateTime: TDateTime;
	public blueArrow: boolean;
	public order: number;
	public Cpd: number;
	public Tor: number;
	public CurrentState: PalletState;

	public constructor(data: IAnyObject) {
		if (typeof data.MilestoneId === "string") {
			this.id = data.MilestoneId;
		}

		if (typeof data.Label === "string") {
			this.label = data.Label;
		}

		if (typeof data.ActualEpochTime === "number") {
			this.actualEpochTime = data.ActualEpochTime;
		}

		if (typeof data.ScheduledEpochTime === "number") {
			this.scheduledEpochTime = data.ScheduledEpochTime;
		}

		if (typeof data.EstimatedEpochTime === "number") {
			this.estimatedEpochTime = data.EstimatedEpochTime;
		}

		if (typeof data.TimezoneOffset === "number") {
			this.timezoneOffset = data.TimezoneOffset;
		}

		if (typeof data.TimeZone === "string") {
			this.timeZone = data.TimeZone;
		}

		if (typeof data.Code === "string") {
			this.code = data.Code;
		}

		if (typeof data.Status === "string") {
			this.status = data.Status;
		}

		if (typeof data.Order === "number") {
			this.order = data.Order;
		}

		if (typeof data.Tor === "number") {
			this.Tor = data.Tor;
		}

		if (typeof data.Cpd === "number") {
			this.Cpd = data.Cpd;
		}

		if (typeof data.CurrentState === "string") {
			this.CurrentState = PalletState[data.CurrentState as keyof typeof PalletState];
		}

		this.blueArrow = false;
	}
}
